import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "da-expansion-panel" }
const _hoisted_2 = { class: "da-expansion-header-title" }
const _hoisted_3 = { ref: "listBody" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "da-expansion-header",
      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clicked && _ctx.clicked(...args)), ["prevent"]))
    }, [
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "header", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.isExpanded ? 'Collapse Details' : 'Expand Details'), 1)
        ])
      ]),
      _createVNode(_component_font_awesome_icon, {
        icon: ['fal', 'angle-up' ],
        class: _normalizeClass(["fa-2x da-expansion-icon", {'da-rotate-180': !_ctx.isExpanded}])
      }, null, 8, ["class"])
    ]),
    _createElementVNode("div", {
      class: "da-expansion-content",
      style: _normalizeStyle(_ctx.heightTransitionCss)
    }, [
      _createElementVNode("div", _hoisted_3, [
        _renderSlot(_ctx.$slots, "content")
      ], 512)
    ], 4)
  ]))
}